import React, { Fragment, useEffect, useRef, useState } from 'react';

const Panel = ({
  children,
  alignment = 'right',
  context = null,
  triggers,
  defaultOpen = false,
  additionalClasses = '',
  overlay = false,
  onOpen = () => {},
}) => {
  const { openTriggerEl, closeTriggerEl, toggleEl } = triggers;

  const [isOpen, setIsOpen] = useState(defaultOpen);

  const handleOpenEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(true);
    onOpen();
  };

  const handleCloseEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(false);
  };

  const dialog = useRef();

  const handleToggleEvent = () => setIsOpen(!isOpen);

  useEffect(() => {
    if (openTriggerEl) openTriggerEl.addEventListener('click', handleOpenEvent);
    if (closeTriggerEl) closeTriggerEl.addEventListener('click', handleCloseEvent);
    if (toggleEl) toggleEl.addEventListener('click', handleToggleEvent);
    if (context) {
      document.addEventListener(`${context}:open`, handleOpenEvent);
      document.addEventListener(`${context}:close`, handleCloseEvent);
    }

    return () => {
      if (openTriggerEl) openTriggerEl.removeEventListener('click', handleOpenEvent);
      if (closeTriggerEl) closeTriggerEl.removeEventListener('click', handleCloseEvent);
      if (toggleEl) toggleEl.removeEventListener('click', handleToggleEvent);
      if (context) {
        document.removeEventListener(`${context}:open`, handleOpenEvent);
        document.removeEventListener(`${context}:close`, handleCloseEvent);
      }
    };
  }, [openTriggerEl, closeTriggerEl, toggleEl]);

  useEffect(() => {
    const body = document.querySelector('body');
    const siteHeader = document.querySelector('site-header');
    const promoBanner = document.querySelector('promo-banner');
    const countdownClockBanner = document.querySelector('#countdown-clock-banner');
    if (isOpen) {
      if (dialog?.current) {
        const focusableEls = dialog.current.querySelectorAll(
          'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), div[role="button"]',
        );
        const firstFocusableEl = focusableEls[0];
        firstFocusableEl?.focus();
      }
      body.classList.add('overflow-hidden');
      siteHeader.style.pointerEvents = 'none';
      if (promoBanner) promoBanner.style.pointerEvents = 'none';
      if (countdownClockBanner) countdownClockBanner.style.pointerEvents = 'none';
    } else {
      body.classList.remove('overflow-hidden');
      siteHeader.style.pointerEvents = 'auto';
      if (promoBanner) promoBanner.style.pointerEvents = 'auto';
      if (countdownClockBanner) countdownClockBanner.style.pointerEvents = 'auto';
    }
  }, [isOpen]);

  const closedClass = alignment === 'right' ? 'translate-x-full' : '-translate-x-full';

  return (
    <Fragment>
      <div
        className={`
        fixed
        bottom-0
        top-0
        z-70
        block
        h-[101dvh]
        w-full
        max-w-[29.4375rem]
        bg-white
        transition-transform
        ${alignment === 'right' ? 'right-0' : 'left-0'} ${
          isOpen ? 'panel-open translate-x-0' : closedClass
        } ${additionalClasses}`}
        role="dialog"
        ref={dialog}
      >
        {children}
      </div>
      {isOpen && overlay && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-30"
          onClick={handleToggleEvent}
          aria-hidden="true"
        ></div>
      )}
    </Fragment>
  );
};

export default Panel;
